import { render, staticRenderFns } from "./datetime.vue?vue&type=template&id=57b2b980&scoped=true"
import script from "./datetime.vue?vue&type=script&lang=js"
export * from "./datetime.vue?vue&type=script&lang=js"
import style0 from "./datetime.vue?vue&type=style&index=0&id=57b2b980&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b2b980",
  null
  
)

export default component.exports